import store from "@/store";

export default {
  install(Vue) {
    Vue.prototype.$can = function (key) {
      return store.getters.user.permissions.includes(key);
    };
  },
};
